import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { css, cx } from 'emotion';
import MultiDownshift from '@weave-design/multi-downshift';
import { CaretDownMUI, CaretDownSUI, CheckmarkSUI, CheckmarkXsUI } from '@weave-design/icons';
import Input from '@weave-design/input';
import ThemeContext, { ThemeContext as ThemeContext$1 } from '@weave-design/theme-context';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function getActiveStyles(isOpen) {
  if (isOpen) {
    return {
      transform: "translateY(-50%) rotate(180deg)"
    };
  }

  return {
    transform: "translateY(-50%)"
  };
}

function stylesheet$3(props, themeData) {
  const padding = props.variant === "box" ? themeData["input.box.paddingHorizontal"] : themeData["input.line.paddingHorizontal"];
  const {
    isOpen,
    stylesheet: customStylesheet
  } = props;
  const styles = {
    inputWrapper: {
      position: "relative"
    },
    caret: _objectSpread2({
      position: "absolute",
      top: "50%",
      right: padding,
      opacity: props.disabled ? themeData["colorScheme.opacity.disabled"] : 1,
      pointerEvents: "none",
      transition: "transform 0.3s, color 0.3s"
    }, getActiveStyles(isOpen))
  };
  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

const _excluded$5 = ["isOpen", "multiple", "onChange", "onInputChange", "stylesheet", "typable"];

function customStylesheet(inputStylesheet, props, themeData) {
  const {
    multiple,
    variant
  } = props;
  return _objectSpread2(_objectSpread2({}, inputStylesheet), {}, {
    input: _objectSpread2(_objectSpread2({}, inputStylesheet.input), {}, {
      cursor: `pointer`,
      whiteSpace: `nowrap`,
      textOverflow: `ellipsis`,
      fontStyle: multiple ? `italic` : {},
      paddingRight: variant === `line` ? `calc(${themeData["density.spacings.large"]} + ${themeData["input.line.paddingHorizontal"]}px)` : `calc(${themeData["density.spacings.large"]} + ${themeData["input.box.paddingHorizontal"]})`
    })
  });
}

function InputPresenter(props) {
  const {
    isOpen,
    multiple,
    onChange,
    onInputChange,
    stylesheet: userStylesheet,
    typable
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$5);

  const dropdownInputStylesheet = (styles, componentProps, themeData) => {
    const dropdownInputStyles = customStylesheet(styles, componentProps, themeData);
    return userStylesheet ? userStylesheet(dropdownInputStyles, componentProps, themeData) : dropdownInputStyles;
  };

  const handleChange = event => {
    onChange(event);

    if (onInputChange) {
      onInputChange(event);
    }
  };

  return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref => {
    let {
      resolvedRoles,
      metadata
    } = _ref;
    const CaretIcon = metadata.densityId === `medium-density` ? CaretDownMUI : CaretDownSUI;
    const iconColor = isOpen ? resolvedRoles[`colorScheme.indicator.on`] : resolvedRoles[`input.indicator.default`];
    return /*#__PURE__*/React.createElement("div", {
      className: css(stylesheet$3(props, resolvedRoles).inputWrapper)
    }, /*#__PURE__*/React.createElement(Input, _extends({}, otherProps, {
      multiple: multiple,
      onChange: handleChange,
      readOnly: !typable,
      stylesheet: dropdownInputStylesheet
    })), /*#__PURE__*/React.createElement(CaretIcon, {
      style: stylesheet$3(props, resolvedRoles).caret,
      color: iconColor
    }));
  });
}
InputPresenter.propTypes = {
  isOpen: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  stylesheet: PropTypes.func,
  typable: PropTypes.bool
};
InputPresenter.__docgenInfo = {
  "description": "",
  "displayName": "InputPresenter",
  "props": {
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "multiple": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onInputChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "typable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var constants = {
  dropdownLayer: 9996,
  menuMaxHeight: "360px"
};

function stylesheet$2(props, themeData) {
  const {
    stylesheet: customStylesheet
  } = props;
  const styles = {
    menu: {
      display: props.isOpen ? "block" : "none",
      position: "absolute",
      width: "100%",
      maxHeight: constants.menuMaxHeight,
      top: themeData["input.minHeight"],
      overflow: "auto",
      zIndex: constants.dropdownLayer,
      boxSizing: "border-box",
      borderTop: "none",
      borderTopLeftRadius: themeData["menu.topFlushBorderTopRadius"],
      borderTopRightRadius: themeData["menu.topFlushBorderTopRadius"],
      borderBottomLeftRadius: themeData["menu.borderRadius"],
      borderBottomRightRadius: themeData["menu.borderRadius"],
      backgroundColor: themeData["menu.backgroundColor"],
      boxShadow: `0 1px ${themeData["basics.shadows.lowBlur"]} ${themeData["colorScheme.shadow.low"]}`
    }
  };
  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

const _excluded$4 = ["children", "innerRef", "isOpen", "stylesheet"];
function MenuPresenter(props) {
  const {
    children,
    innerRef,
    isOpen,
    stylesheet: customStylesheet
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$4);

  const {
    className
  } = otherProps;
  return /*#__PURE__*/React.createElement(ThemeContext$1.Consumer, null, _ref => {
    let {
      resolvedRoles
    } = _ref;
    return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
      ref: innerRef,
      className: cx(css(stylesheet$2(props, resolvedRoles).menu), className)
    }), children);
  });
}
MenuPresenter.propTypes = {
  innerRef: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  stylesheet: PropTypes.func
};
MenuPresenter.__docgenInfo = {
  "description": "",
  "displayName": "MenuPresenter",
  "props": {
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

function stylesheet$1(props) {
  const {
    stylesheet: customStylesheet
  } = props;
  const styles = {
    dropdownWrapper: {
      position: "relative",
      width: "100%"
    }
  };
  return customStylesheet ? customStylesheet(styles, props) : styles;
}

const _excluded$3 = ["children", "disabled", "stylesheet"];
/**
 * @typedef {Object} WrapperProps
 * @property {JSX.Element} [input]
 * @property {JSX.Element} [menu]
 * @property {boolean} [isOpen]
 */

/**
 * Downshift requires a reference to the component's root element.
 * As a result, this presenter should be purely functional so that it can
 * be used as function with Downshift.
 *
 * @param {WrapperProps} prop
 * @returns {JSX.Element}
 * @see https://github.com/paypal/downshift#getrootprops
 */

function WrapperPresenter(props) {
  const {
    children,
    disabled,
    stylesheet: customStylesheet
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$3);

  const {
    className
  } = otherProps;
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: cx(css(stylesheet$1(props).dropdownWrapper), className)
  }), children);
}
WrapperPresenter.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  stylesheet: PropTypes.func
};
WrapperPresenter.__docgenInfo = {
  "description": "Downshift requires a reference to the component's root element.\nAs a result, this presenter should be purely functional so that it can\nbe used as function with Downshift.\n\n@param {WrapperProps} prop\n@returns {JSX.Element}\n@see https://github.com/paypal/downshift#getrootprops",
  "displayName": "WrapperPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */

var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */

var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * @typedef {Object} ButtonEventHandlers
 * @property {function(MouseEvent, ...any): void} handleClick
 * @property {function(KeyboardEvent, ...any): void} handleKeyDown
 */

/**
 * @typedef {Object} Options
 * @property {boolean} [preventDefault]
 */


const KEYBOARD_INTERACTIONS = [" ", "Enter"];
/**
 * Create event handlers for native button behavior for non-button elements
 * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role
 *
 * @param {function(MouseEvent|KeyboardEvent, ...any): void} [handler] the event handler function
 * @param {Options} [options]
 * @returns {ButtonEventHandlers}
 */

function createButtonEventHandlers(handler) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!handler) return {};
  const {
    preventDefault = true
  } = options;
  return {
    handleClick: handler,

    handleKeyDown(event) {
      const {
        key
      } = event;
      if (!KEYBOARD_INTERACTIONS.includes(key)) return; // Prevent space key default scrolling behavior

      if (preventDefault) event.preventDefault();

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      handler(event, ...args);
    }

  };
}

function stylesheet(props, themeData) {
  const {
    stylesheet: customStylesheet
  } = props;
  const styles = {
    option: _objectSpread2(_objectSpread2(_objectSpread2({
      margin: 0,
      display: "flex",
      position: "relative",
      boxSizing: "border-box",
      minHeight: themeData[`menu.item.minHeight`],
      alignItems: "center",
      padding: `${themeData["menu.item.paddingVertical"]}
        ${themeData["menu.item.paddingHorizontal"]}`,
      cursor: "pointer",
      color: themeData[`typography.body.color`],
      fontFamily: themeData[`typography.body.fontFamily`],
      fontWeight: themeData[`typography.body.fontWeight`],
      fontSize: themeData[`typography.body.fontSize`],
      lineHeight: themeData[`typography.body.lineHeight`],
      backgroundColor: "transparent",
      transition: `background-color 0.3s cubic-bezier(0.4,0,0.2,1)`
    }, props.highlighted && !props.disabled ? {
      backgroundColor: themeData["menu.item.hover.backgroundColor"]
    } : null), props.disabled ? {
      opacity: themeData["colorScheme.opacity.disabled"]
    } : null), {}, {
      "&:active": {
        backgroundColor: themeData[`menu.item.pressed.backgroundColor`]
      }
    }),
    optionCheckWrapper: {
      height: themeData[`menu.item.minHeight`],
      marginRight: themeData[`menu.item.paddingHorizontal`],
      display: `flex`,
      order: -1,
      alignItems: `center`,
      "& > svg *": _objectSpread2(_objectSpread2({
        transition: `opacity 0.3s cubic-bezier(0.4,0,0.2,1)`,
        opacity: 0
      }, props.highlighted && !props.disabled ? {
        opacity: 1,
        fill: themeData[`menu.item.checkmark.hover.iconColor`],
        transition: `opacity 0.3s cubic-bezier(0.4,0,0.2,1)`
      } : {}), props.selected ? {
        opacity: 1,
        fill: themeData[`menu.item.checkmark.active.iconColor`],
        transition: `opacity 0.3s cubic-bezier(0.4,0,0.2,1)`
      } : {})
    }
  };
  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

const _excluded$2 = ["children", "selected"];

function OptionWrapper(props) {
  const {
    children,
    disabled,
    id,
    onClick,
    onMouseDown,
    onMouseMove,
    selected,
    highlighted
  } = props;
  const {
    handleClick,
    handleKeyDown
  } = createButtonEventHandlers(onClick);
  return /*#__PURE__*/React.createElement(ThemeContext$1.Consumer, null, _ref => {
    let {
      resolvedRoles
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      "aria-selected": selected,
      className: css(stylesheet(_objectSpread2({
        disabled,
        selected,
        highlighted
      }, props), resolvedRoles).option),
      disabled: disabled,
      id: id,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      onMouseDown: onMouseDown,
      onMouseMove: onMouseMove,
      role: "option",
      tabIndex: "0"
    }, children);
  });
}

OptionWrapper.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  highlighted: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  selected: PropTypes.bool
};

const OptionPresenter = props => {
  const {
    children,
    selected
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$2);

  return /*#__PURE__*/React.createElement(ThemeContext$1.Consumer, null, _ref2 => {
    let {
      resolvedRoles,
      metadata
    } = _ref2;
    const Icon = metadata.densityId === "medium-density" ? CheckmarkSUI : CheckmarkXsUI;
    const styles = stylesheet(props, resolvedRoles);
    return /*#__PURE__*/React.createElement(OptionWrapper, _extends({
      selected: selected
    }, otherProps), /*#__PURE__*/React.createElement("span", null, children), /*#__PURE__*/React.createElement("div", {
      className: css(styles.optionCheckWrapper)
    }, /*#__PURE__*/React.createElement(Icon, null)));
  });
};

OptionPresenter.displayName = "OptionPresenter";
OptionPresenter.propTypes = {
  /**
   * Visual representation of the option
   */
  children: PropTypes.node,

  /**
   * Indicates the option is currently highlighted.
   * This is comparable to hover state, but useful when interacting by keyboard.
   */
  highlighted: PropTypes.bool,

  /**
   * Called when user finishes clicking on an option
   */
  onClick: PropTypes.func,

  /**
   * Called when user begins clicking on an option
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when user moves mouse over the option
   */
  onMouseMove: PropTypes.func,

  /**
   * Indicates the option is currently selected
   */
  selected: PropTypes.bool
};
OptionPresenter.__docgenInfo = {
  "description": "",
  "displayName": "OptionPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Visual representation of the option"
    },
    "highlighted": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Indicates the option is currently highlighted.\nThis is comparable to hover state, but useful when interacting by keyboard."
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user finishes clicking on an option"
    },
    "onMouseDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user begins clicking on an option"
    },
    "onMouseMove": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user moves mouse over the option"
    },
    "selected": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Indicates the option is currently selected"
    }
  }
};

const _excluded$1 = ["formatOption", "getItemProps", "highlightedIndex", "multiple", "options", "renderOption", "selectedItem", "selectedItems"];
/**
 * @typedef {any} OptionMeta
 */

/** @typedef {import("downshift").ControllerStateAndHelpers} DownshiftHelpers */

/**
 * @param {DownshiftHelpers} downshift
 * @returns {function(OptionMeta): boolean}
 */

function createSelectedDeterminer(downshift) {
  const {
    multiple,
    selectedItem,
    selectedItems
  } = downshift;
  return option => multiple ? selectedItems.includes(option) : option === selectedItem;
}
/**
 * @param {DownshiftHelpers} downshift
 * @param {function(Object)} renderOption
 * @returns {function(OptionMeta, number): JSX.Element}
 */


function createOptionRenderer(downshift, renderOption, otherProps) {
  const {
    formatOption,
    getItemProps,
    highlightedIndex
  } = downshift;
  const isSelected = createSelectedDeterminer(downshift);
  const {
    stylesheet: customStylesheet
  } = otherProps;
  return (option, index) => {
    const itemProps = getItemProps({
      index,
      key: `option-${index}`,
      item: option && option.item ? option.item : option,
      disabled: option && option.disabled ? option.disabled : false,
      selected: option && option.item ? isSelected(option.item) : isSelected(option),
      highlighted: highlightedIndex === index
    });
    let result;

    if (option && option.render !== undefined) {
      result = option.render(option, itemProps);
    } else if (renderOption !== undefined) {
      result = renderOption(option, itemProps);
    } else {
      const optionLabel = option && option.item ? option.item : option;
      result = /*#__PURE__*/React.createElement(OptionPresenter, _extends({}, itemProps, {
        stylesheet: customStylesheet
      }), formatOption(optionLabel));
    }

    return result;
  };
}
/** @typedef {DownshiftHelpers & { options: OptionMeta[] }} RenderOptionsProps */

/**
 * @param {RenderOptionsProps} props
 * @todo Convert into a functional component once `React.Fragment` can be used
 */


function renderOptions(props) {
  const {
    formatOption = option => String(option),
    getItemProps = itemProps => itemProps,
    highlightedIndex,
    multiple = false,
    options = [],
    renderOption,
    selectedItem,
    selectedItems = []
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$1);

  const downshift = {
    formatOption,
    getItemProps,
    highlightedIndex,
    multiple,
    selectedItem,
    selectedItems
  };
  const optionRenderer = createOptionRenderer(downshift, renderOption, otherProps);
  return options.map(optionRenderer);
}

const _excluded = ["placeholder", "disabled", "required", "onBlur", "onFocus", "onInputChange", "variant", "error", "stylesheet", "typable", "multiple"],
      _excluded2 = ["formatOption", "multiple", "options", "renderOption", "stylesheet"],
      _excluded3 = ["defaultValue", "disabled", "formatOption", "id", "multiple", "onBlur", "onChange", "onFocus", "onInputChange", "options", "placeholder", "renderOption", "required", "typable", "value", "variant", "error"];
/** @typedef {import("./presenters/renderOptions").OptionMeta} OptionMeta */

/** @typedef {import("downshift").ControllerStateAndHelpers} DownshiftHelpers */

const variantTypes = ["line", "box"];

const Dropdown = props => {
  /**
   * The controlled value for the input element
   * @see https://github.com/paypal/downshift#inputvalue
   * @returns {string|undefined}
   */
  const getInputValue = () => {
    const {
      multiple,
      formatOption,
      value
    } = props;

    if (value === undefined) {
      return undefined;
    }

    if (multiple) {
      return value.map(formatOption).join(", ");
    }

    return formatOption(value);
  };
  /**
   * > Why not just pass the `props.onChange` directly to Downshift?
   *
   *  Downshift provides all of it's helpers and state to `onChange`.
   *  We don't want to expose the entire Downshift API to consumers.
   *
   * @param {OptionMeta | OptionMeta[]} value
   * @param {DownshiftHelpers} downshift
   */


  const handleChange = value => {
    const {
      onChange
    } = props;

    if (onChange) {
      onChange(value);
    }
  };

  const getBehaviorProps = () => {
    const {
      id,
      multiple,
      formatOption,
      value,
      defaultValue
    } = props;
    const valuePropName = multiple ? "selectedItems" : "selectedItem";
    const defaultValuePropName = multiple ? "initialSelectedItems" : "initialSelectedItem";
    return {
      id,
      onChange: handleChange,
      itemToString: formatOption,
      [valuePropName]: value,
      [defaultValuePropName]: defaultValue,
      inputValue: getInputValue()
    };
  };
  /**
   * @param {DownshiftHelpers} downshift
   * @returns {JSX.Element}
   */


  const renderInput = downshift => {
    const {
      id,
      isOpen,
      toggleMenu,
      getInputProps
    } = downshift;

    const {
      placeholder,
      disabled,
      required,
      onBlur,
      onFocus,
      onInputChange,
      variant,
      error,
      stylesheet: customStylesheet,
      typable,
      multiple
    } = props,
          otherProps = _objectWithoutProperties(props, _excluded);

    const {
      className,
      tabIndex
    } = otherProps;
    const inputClassName = className && className.split(" ").reduce((acc, cur) => cx(acc, `${cur.trim()}-input-wrapper`), "");
    const inputProps = getInputProps({
      id,
      error,
      placeholder,
      disabled,
      isOpen,
      required,
      onBlur,
      onFocus,
      onClick: toggleMenu,
      onInputChange,
      tabIndex,
      variant,
      className: inputClassName,
      stylesheet: customStylesheet,
      typable,
      multiple
    });
    return /*#__PURE__*/React.createElement(InputPresenter, _extends({
      key: "input"
    }, inputProps));
  };
  /**
   * @param {DownshiftHelpers} downshift
   * @returns {JSX.Element}
   */


  const renderMenu = downshift => {
    const {
      getItemProps,
      getMenuProps,
      highlightedIndex,
      isOpen,
      selectedItem,
      selectedItems
    } = downshift;

    const {
      formatOption,
      multiple,
      options,
      renderOption,
      stylesheet: customStylesheet
    } = props,
          otherProps = _objectWithoutProperties(props, _excluded2);

    const {
      className
    } = otherProps;
    const menuClassName = className && className.split(" ").reduce((acc, cur) => cx(acc, `${cur.trim()}-menu-wrapper`), "");
    const menuProps = getMenuProps({
      isOpen,
      refKey: "innerRef",
      className: menuClassName,
      stylesheet: customStylesheet
    });
    const children = renderOptions({
      formatOption,
      getItemProps,
      highlightedIndex,
      multiple,
      options,
      renderOption,
      selectedItem,
      selectedItems,
      stylesheet: customStylesheet
    });
    return /*#__PURE__*/React.createElement(MenuPresenter, _extends({
      key: "menu"
    }, menuProps), children);
  };
  /**
   * @param {DownshiftHelpers} downshift
   * @returns {JSX.Element}
   */


  const renderPresenter = downshift => {
    const {
      defaultValue,
      disabled,
      formatOption,
      id,
      multiple,
      onBlur,
      onChange,
      onFocus,
      onInputChange,
      options,
      placeholder,
      renderOption,
      required,
      typable,
      value,
      variant,
      error
    } = props,
          otherProps = _objectWithoutProperties(props, _excluded3);
    /**
     * The `Wrapper` presenter is used as a function to avoid having to
     * use Downshift's `getRootProps`
     * @see https://github.com/paypal/downshift#getrootprops
     */


    return WrapperPresenter(_objectSpread2({
      disabled,
      children: [renderInput(downshift), renderMenu(downshift)]
    }, otherProps));
  };

  const {
    multiple
  } = props;
  const Behavior = multiple ? MultiDownshift : Downshift;
  return /*#__PURE__*/React.createElement(Behavior, getBehaviorProps(), renderPresenter);
};

Dropdown.displayName = "Dropdown";
Dropdown.propTypes = {
  /**
   * The default value when the component is uncontrolled
   */
  defaultValue: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]),

  /**
   * Prevents user actions on the field
   */
  disabled: PropTypes.bool,

  /**
   * Specifies if the value provided is wrong
   */
  error: PropTypes.bool,

  /**
   * Used to format options into human readable strings
   *
   * Note that if both formatOption and renderOption are provided,
   * renderOption will take precedence
   */
  formatOption: PropTypes.func,

  /**
   * HTML ID attribute
   */
  id: PropTypes.string,

  /**
   * Enables multiple selection
   */
  multiple: PropTypes.bool,

  /**
   * Called when the text field is blurred
   */
  onBlur: PropTypes.func,

  /**
   * Called with the selected option when the value changes
   */
  onChange: PropTypes.func,

  /**
   * Called when the text field is focused
   */
  onFocus: PropTypes.func,

  /**
   * Called when the input field value changes via typing
   * Meant to be used when the `typable` prop is set to `true`,
   * otherwise use `onChange`
   */
  onInputChange: PropTypes.func,

  /**
   * An array of unique values of any type except `undefined`
   * If you use an array of objects, the object must contain the property `item`,
   * the option's disabled state can be controlled with a `disabled` property.
   */
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.any),

  /**
   * Placeholder text to render when an option has not been selected
   */
  placeholder: PropTypes.string,

  /**
   * When present, this function is used to render each option.  Each
   * option is passed as an argument. If any option has Option.render
   * prop present, that will take precedence and this
   * function will not be called for that option.
   *
   * In  addition to the option passed as an argument, props
   * are also passed in that can be used for each option to help
   * maintain some of the built-in `Dropdown` option functionality.
   *
   * Similarly if both formatOption and renderOption are provided,
   * renderOption will take precedence
   */
  renderOption: PropTypes.func,

  /**
   * Text describing why the field is required
   */
  required: PropTypes.string,

  /**
   * Adds custom/overriding styles
   */
  stylesheet: PropTypes.func,

  /**
   * Allows the input to be typable
   */
  typable: PropTypes.bool,

  /**
   * The value of the control
   */
  value: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]),

  /**
   * The visual variant of the textarea
   */
  variant: PropTypes.oneOf(variantTypes)
};
Dropdown.defaultProps = {
  /**
   * @param {OptionMeta} option
   * @returns {string}
   */
  formatOption(option) {
    return option ? String(option) : "";
  },

  typable: false
};
Dropdown.__docgenInfo = {
  "description": "",
  "displayName": "Dropdown",
  "props": {
    "defaultValue": {
      "type": {
        "name": "union",
        "value": [{
          "name": "any"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "any"
          }
        }]
      },
      "required": false,
      "description": "The default value when the component is uncontrolled"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Prevents user actions on the field"
    },
    "error": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Specifies if the value provided is wrong"
    },
    "formatOption": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Used to format options into human readable strings\n\nNote that if both formatOption and renderOption are provided,\nrenderOption will take precedence",
      "defaultValue": {
        "value": "function(option) {\n  return option ? String(option) : \"\";\n}",
        "computed": false
      }
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "HTML ID attribute"
    },
    "multiple": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Enables multiple selection"
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when the text field is blurred"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called with the selected option when the value changes"
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when the text field is focused"
    },
    "onInputChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when the input field value changes via typing\nMeant to be used when the `typable` prop is set to `true`,\notherwise use `onChange`"
    },
    "options": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "any"
        }
      },
      "required": false,
      "description": "An array of unique values of any type except `undefined`\nIf you use an array of objects, the object must contain the property `item`,\nthe option's disabled state can be controlled with a `disabled` property."
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder text to render when an option has not been selected"
    },
    "renderOption": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When present, this function is used to render each option.  Each\noption is passed as an argument. If any option has Option.render\nprop present, that will take precedence and this\nfunction will not be called for that option.\n\nIn  addition to the option passed as an argument, props\nare also passed in that can be used for each option to help\nmaintain some of the built-in `Dropdown` option functionality.\n\nSimilarly if both formatOption and renderOption are provided,\nrenderOption will take precedence"
    },
    "required": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text describing why the field is required"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    },
    "typable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Allows the input to be typable",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "any"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "any"
          }
        }]
      },
      "required": false,
      "description": "The value of the control"
    },
    "variant": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"line\"",
          "computed": false
        }, {
          "value": "\"box\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "The visual variant of the textarea"
    }
  }
};

export { Dropdown as default };
